import { render } from "./BgyxMenuItem.vue?vue&type=template&id=5dfb69b2"
import script from "./BgyxMenuItem.vue?vue&type=script&lang=js"
export * from "./BgyxMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__